import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { DAILY_LOAD_GOALS_STATISTICS_GET } from 'api/query-keys';
import type { TCargoType, TGetDailyLoadGoalsStatisticsRes } from 'api/swagger';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  date: string;
  transportLine: string;
  cargoTypes: TCargoType[];
}

export const useGetDailyGoalsStatistics = (params: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IParams>(qs, params);

  return useQuery({
    queryKey: [DAILY_LOAD_GOALS_STATISTICS_GET, { params }],
    queryFn: async () => {
      const { data } = await http.get<TGetDailyLoadGoalsStatisticsRes>(
        `/v1/statistics/daily-load-goals?${qs.toString()}`,
      );
      return data;
    },
    enabled: !!params.transportLine,
  });
};
